/**
 * @flow
 */

const logger = {
  debug: (_: any) => {},
  info: (_: any) => {},
  warn: (_: any) => {},
  error: (_: any) => {},
  log: (_: any, __: any) => {},
};

window.console = logger;
